<p-table [value]="form().controls" size="small" >
    <ng-template pTemplate="header">
        <tr>
            <th>Codice</th>
            <th>Titolo</th>
            <th>Quantità</th>
            <th>Data scadenza</th>
            <th>Note</th>
             @if (!isFormDisabled()) {<th style="width: 1rem"></th>}
            
        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowGroup let-i="rowIndex">
        <tr [formGroup]="$any(rowGroup)">
            <td class="p-0"><spike-field-text formControlName="code" placeholder="Codice"></spike-field-text></td>
            <td class="p-0"><spike-field-text formControlName="shortDescription" placeholder="Titolo"></spike-field-text></td>
            <td class="p-0"><spike-field-number formControlName="quantity" placeholder="Quantità"></spike-field-number></td>
            <td class="p-0"><spike-field-date formControlName="expireDate" placeholder="23/10/2025"></spike-field-date></td>
            <td class="p-0"><spike-field-text formControlName="description" placeholder="Note" class="w-full"></spike-field-text></td>
            <td class="p-0" >
                @if (!isFormDisabled()) {
                <div (click)="deleteRow.emit(i)" class="cursor-pointer" ><i class="pi pi-trash" style="color: var(--p-button-text-danger-color)"></i></div>
                 }
            </td>
           
        </tr>
    </ng-template>

    <ng-template pTemplate="summary">
        @if(!isFormDisabled()){
        <div class="flex justify-content-end">
            <p-button label="Aggiungi Posizione" icon="pi pi-plus" [text]="true" size="small" (onClick)="addRow.emit()"></p-button>
        </div>
        }
    </ng-template>
</p-table>